import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DataPopover from 'components/DataPopover';
import ScalingTextBlock from 'components/ScalingTextBlock';
import TextButton from 'components/TextButton';
import shouldUpdate from 'utils/shouldUpdate';
import './TruncatingTextBlock.css';

const READ_MORE_LENGTH = '... (read more)'.length;

function truncateText(text, limit) {
  if (!text || text.length <= limit) {
    return text;
  }
  return (
    <span>
      <span>{text.substring(0, limit - READ_MORE_LENGTH).trim() + '... '}</span>
      <span className="read-more">(read&nbsp;more)</span>
    </span>
  );
}

function TruncatingTextBlock({
  className,
  text,
  maxLength,
  maxHeight,
  tooltipClass = '',
  container = undefined,
  placement
}) {
  const truncatedText = truncateText(text, maxLength);
  const setClassName = `truncating-text-block ${className || ''}`;

  let content = (
    <ScalingTextBlock maxHeight={maxHeight}>{truncatedText}</ScalingTextBlock>
  );

  if (truncatedText !== text) {
    content = (
      <Fragment>
        <DataPopover
          tooltipMessage={text}
          tooltipClass={tooltipClass}
          placement={placement || 'bottom'}
          trigger="click"
          rootClose
          container={container}
        >
          <TextButton aria-hidden="true">{content}</TextButton>
        </DataPopover>
        <span className="sr-only">{text}</span>
      </Fragment>
    );
  }

  return <div className={setClassName}>{content}</div>;
}

TruncatingTextBlock.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  maxLength: PropTypes.number,
  maxHeight: PropTypes.string,
  tooltipClass: PropTypes.string
};

function shouldComponentUpdate(props, nextProps) {
  return (
    props.className !== nextProps.className ||
    props.text !== nextProps.text ||
    props.maxLength !== nextProps.maxLength ||
    props.maxHeight !== nextProps.maxHeight ||
    props.tooltipClass !== nextProps.tooltipClass ||
    props.container !== nextProps.container
  );
}

export default shouldUpdate(shouldComponentUpdate)(TruncatingTextBlock);
